import React from 'react';

import { Skeleton as MUISkeleton, type SkeletonProps, useTheme } from '@mui/material';

export const Skeleton = (props: SkeletonProps) => {
  const { sx, ...rest } = props;
  const { spacing } = useTheme();
  return (
    <MUISkeleton
      variant="rectangular"
      sx={{
        width: '100%',
        borderRadius: spacing(4),
        height: '100%',
        ...sx,
      }}
      {...rest}
    />
  );
};
